import { APICore } from "helpers/api/apiCore";
import { unmaskPiiFieldByUrl } from "helpers/piiUnmask";
import config from "../../../config";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function fetchExcessRefundApi(params: FilterMetadata) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-refund/refunds`;
  return api.get(`${baseUrl}`, params);
}

function fetchExcessRefundByExternalIdApi(params: any) {
  const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-refund/refunds/${params?.id}`;
  return api.get(`${baseUrl}`, {});
}

function unmaskExcessRefundPiiFieldApi(recordId: string, fieldName: string) {
  return unmaskPiiFieldByUrl(`${config.REPAYMENT_BASE_URL}/repayment-excess-refund/refunds/${recordId}/pii/unmask`, fieldName);
}

export { fetchExcessRefundApi, fetchExcessRefundByExternalIdApi, unmaskExcessRefundPiiFieldApi };
